import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { PlusCircle, Eye } from "react-feather";
import MasterDetailListShell from "../../../../../components/layout/MasterDetailListShell";
import MasterDetailRow from "../../../../../components/layout/MasterDetailRow";
import PrototypeCreateModal from "./PrototypeCreateModal";
import { useListQuotationPrototypesQuery } from "../../quotationsApi";
import { useCanManagePrototype } from "../../useQuotationPermissions";
import { useBranchFilter } from "../../../../branchFilter/useBranchFilter";
import { paths } from "../../../../../routes/paths";

const PrototypeCompactList = () => {
  const canManage = useCanManagePrototype();
  const navigate = useNavigate();
  const { recordGuid: selectedRecordGuid } = useParams();
  const [searchInput, setSearchInput] = useState("");
  const [search, setSearch] = useState("");
  const [isActive, setIsActive] = useState("");
  const [showCreateModal, setShowCreateModal] = useState(false);
  const { selectedBranchId } = useBranchFilter();

  useEffect(() => {
    const handle = setTimeout(() => setSearch(searchInput.trim()), 400);
    return () => clearTimeout(handle);
  }, [searchInput]);

  const { data: items = [], isLoading } = useListQuotationPrototypesQuery({
    branchId: selectedBranchId ?? undefined,
    isActive: isActive === "" ? undefined : isActive === "true",
    search: search || undefined,
  });

  return (
    <>
    <MasterDetailListShell
      title="Quotation Prototypes"
      addButton={
        canManage && (
          <button type="button" className="btn btn-added" onClick={() => setShowCreateModal(true)}>
            <PlusCircle className="me-2" size={16} />
            New Prototype
          </button>
        )
      }
      filters={
        <>
          <input
            type="text"
            placeholder="Search by name"
            className="form-control form-control-sm"
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
          />
          <div className="d-flex gap-2 mt-2">
            <select className="form-control form-control-sm" value={isActive} onChange={(e) => setIsActive(e.target.value)}>
              <option value="">All</option>
              <option value="true">Active</option>
              <option value="false">Inactive</option>
            </select>
          </div>
        </>
      }
      isLoading={isLoading}
      emptyLabel="No quotation prototypes match these filters."
      items={items}
      getKey={(p) => p.recordGuid}
      resetKey={`${search}|${isActive}|${selectedBranchId}`}
      renderItem={(p) => {
        const isSelected = String(p.recordGuid) === String(selectedRecordGuid);
        return (
          <MasterDetailRow
            isSelected={isSelected}
            onClick={() => navigate(paths.quotationPrototypeDetail(p.recordGuid))}
            avatarLabel={(p.name || "?").trim().slice(0, 2).toUpperCase()}
            title={p.name}
            subtitle={<>{p.branchCode} &middot; {p.lineCount} line{p.lineCount === 1 ? "" : "s"}</>}
            badge={!p.isActive && <span className="badge badge-linesecondary me-2">Inactive</span>}
            actions={
              <button
                type="button"
                className="btn btn-link p-1"
                title="View"
                onClick={(ev) => {
                  ev.stopPropagation();
                  navigate(paths.quotationPrototypeDetail(p.recordGuid));
                }}
              >
                <Eye size={15} />
              </button>
            }
          />
        );
      }}
    />
    <PrototypeCreateModal show={showCreateModal} onClose={() => setShowCreateModal(false)} />
    </>
  );
};

export default PrototypeCompactList;
